import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import EventStaffingIndustry from "@/pages/industries/EventStaffingIndustry";
export const Route = createFileRoute("/industries/event-staffing")({ head: ({match}) => pageHead(match.pathname), component: () => (<EventStaffingIndustry />) });
